window.VH = window.VH === undefined ? {} : window.VH;

VH.RelationObject = {
    triggerOwner : null,
    widgetContainer : null,
    hiddenField : null,
    visibleField : null,

    init : function init(owner)
    {
        let _t = VH.RelationObject;
        _t.triggerOwner = owner;
        _t.widgetContainer = _t.triggerOwner.closest('.relationWidget');
        _t.hiddenField = _t.widgetContainer.parent().find('.relationHiddenInput');
        _t.visibleField = _t.widgetContainer.find('.relationVisibleInput');
    }
};

VH.Relation = {
    ro : VH.RelationObject,
    container : null,
    modal : null,
    changeTimeout : null,

    updateContainer : function updateContainer(url, addParams, element) {
        let _t = VH.Relation,
            elementId = (element !== undefined) ? '#' + element.attr('id') : undefined;

        addParams = addParams === undefined ? {} : addParams;
        $.post(url, addParams, function(data) {
            _t.container.html(data);
            _t.container.data('url', url);
            if (elementId !== undefined) {
                let el = _t.container.find(elementId);
                if (el.length > 0) {
                    el.focus();
                    el[0].setSelectionRange(10000, 10000);
                }
            }
        });
    },


    initAjaxLinks : function initAjaxLinks()
    {
        let _t = VH.Relation,
            w = $('#wrapper')
        ;

        w.on('click', '.relationAjaxModal', function () {
            let t = $(this),
                url = t.attr('href');

            _t.ro.init(t);

            $('.modal-header h4', _t.modal).html(t.data('ajax-modal-title'));
            _t.modal.modal('show');
            if (url !== '#') {
                $(_t.container).html('Loading...');
                _t.updateContainer(url);
            }
            return false;
        });

        w.on('click', '.relationWidgetClear', function () {
            let t = $(this);

            _t.ro.init(t);
            _t.ro.hiddenField.val('');
            _t.ro.visibleField.val('');

            _t.ro.hiddenField.trigger('relation.clear');
            _t.ro.hiddenField.trigger('change');

            return false;
        });

        _t.modal.on('hide.bs.modal', function() {
            _t.triggerOwner = null;
        });

    },

    getUrl : function getUrl() {
        let _t = VH.Relation;
        return _t.container.data('url');
    },

    init : function init()
    {
        let _t = VH.Relation;

        _t.modal = $('#relationAjaxModal');
        _t.container = $('#relationAjaxModalContent');
        _t.initAjaxLinks();

        _t.container.on('click', '.selectItem', function () {
            let t = $(this);

            _t.ro.visibleField.val(t.data('title'));
            _t.ro.hiddenField.val(t.data('pk'));
            _t.ro.hiddenField.trigger('relation.change', {selectData : t.data('select-data')});
            _t.ro.hiddenField.trigger('change');

            _t.modal.modal('hide');
            return false;
        });

        _t.container.on('click', 'a', function () {
            let t = $(this),
                url = t.attr('href');

            if (url !== '#') {
                _t.updateContainer(url);
            }

            return false;
        });

        _t.container.on('click', '.clearFilter', function () {
            let t = $(this),
                url = new URL(_t.getUrl(), window.location.origin)
            ;

            t.closest('.filters').find('input').each(function() {
                url.searchParams.set($(this).attr('name'), '');
            });

            _t.updateContainer(url.href);

            return false;
        });

        _t.container.on('keyup', 'input', function(e) {
            let keyCode = e.keyCode || e.which,
                t = $(this);

            e.preventDefault();

            if (t.closest('.filters').length > 0) {
                if (_t.changeTimeout !== null) {
                    clearTimeout(_t.changeTimeout);
                    _t.changeTimeout = null;
                }
                _t.changeTimeout = setTimeout(function () {
                    t.trigger('change', e);
                }, 500);
            }

            return false;
        });

        _t.container.on('keydown', 'input', function(e) {
            let keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();
                return false;
            }
        });

        _t.container.on('change', '.filters input', function(e) {
            let url = new URL(_t.getUrl(), window.location.origin),
                t = $(this);

            url.searchParams.set(t.attr('name'), t.val());
            _t.updateContainer(url.href, undefined, t);

            return false;
        });

    }
};
